

import { useSelector } from "react-redux";
import UpgradeCard from "./UpgradeCard";

const FeatureGuard = ({
  feature,
  children,
}) => {
  const { features } = useSelector(
    (state) => state.subscriptionSlice
  );


  const hasAccess =
    features?.includes(feature);


  if (!hasAccess) {
    return (
      <UpgradeCard
        title="Upgrade Required"
        description="Your current plan does not include access to this feature."
      />
    );
  }

  return children;
};

export default FeatureGuard;